/**
 * 会员信息
 */
import React from 'react';

import { Row, Col, Icon, Tooltip, Progress } from 'antd';

import PageLayout from '../../ui/PageLayout';

import OrgSelect from '../../ui/OrgSelect';

import RentSumDetail from './RentSumDetail';

import { fixedNumber } from '../../../util/util';

class RentSumIndex extends React.Component {

    columns = [{
        title: '所属市场',
        dataIndex: 'orgName',
        width: '10%',
    }, {
        title: '月份',
        dataIndex: 'month',
        width: '10%',
    }, {
        title: '租金',
        dataIndex: 'totalRentFees',
        width: '10%',
    },{
        title: '物业费',
        dataIndex: 'totalPropertyFees',
        width: '10%',
    }, {
        title: '水费',
        dataIndex: 'waterFees',
        width: '10%',
    }, {
        title: '电费',
        dataIndex: 'electricityFees',
        width: '10%',
    }, {
        title: '应收费用',
        dataIndex: 'totalFees',
        width: '10%',
    }, {
        title: '收费进度',
        dataIndex: 'chargedFees',
        width: '10%',
        render: (text, record, index) =>
            <Tooltip title={"已收费金额（" + text + "）/ 应收费金额（" + record["totalFees"] + "）"}>
                <Progress percent={fixedNumber((text / record["totalFees"] * 100), 2)} />
            </Tooltip>
    }, {
        title: '审核进度',
        dataIndex: 'auditFees',
        width: '10%',
        render: (text, record, index) =>
            <Tooltip title={"已审核金额（" + text + "）/ 应审核金额（" + record["totalFees"] + "）"}>
                <Progress percent={fixedNumber((text / record["totalFees"] * 100).toFixed(2), 2)} />
            </Tooltip>
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) =>
            <Tooltip title="明细">
                <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
            </Tooltip>
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
    };

    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    showModal = () => {
        this.setState({ visible: true });
    };
    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    detail = (info, e) => {
        this.setState({ editData: info });
        this.showModal();
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <OrgSelect style={{ width: '250px'}} 
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={2}
                                    treeDefaultExpandAll={true} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                            </Col>
                        </Row>
                    )}
                    initParams={this.state.queryData}
                    rowKey="id" url="/tenantFees/findTenantFeesSumPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }); }}
                />
                <RentSumDetail
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                />
            </div>
        )
    }
}

export default RentSumIndex;